export type Tema = 'automatico' | 'claro' | 'escuro';

const CHAVE = 'raiox:tema';

export function lerTema(): Tema {
  try {
    const v = localStorage.getItem(CHAVE);
    if (v === 'claro' || v === 'escuro' || v === 'automatico') return v;
  } catch {
    // localStorage bloqueado (janela privativa, cookies de terceiros): segue no automático.
  }
  return 'automatico';
}

export function aplicarTema(tema: Tema): void {
  const raiz = document.documentElement;
  if (tema === 'claro') raiz.setAttribute('data-theme', 'light');
  else if (tema === 'escuro') raiz.setAttribute('data-theme', 'dark');
  else raiz.removeAttribute('data-theme');
  try {
    localStorage.setItem(CHAVE, tema);
  } catch {
    // sem persistência: o tema vale só para esta aba.
  }
}

export function proximoTema(tema: Tema): Tema {
  if (tema === 'automatico') return 'claro';
  if (tema === 'claro') return 'escuro';
  return 'automatico';
}

export const ROTULO_TEMA: Record<Tema, string> = {
  automatico: 'Tema: sistema',
  claro: 'Tema: claro',
  escuro: 'Tema: escuro',
};
